module.exports = __webpack_public_path__ + "img/quality.76d8445.png";